import { Controller } from '../utils/controller';
import debounce from 'lodash/debounce';

const SCROLL_TOP_BREAKPOINT = 100;

export default class extends Controller {
  static targets = ['siteHeader'];
  static requiredTargets = [];

  static classes = ['onTop', 'overScrollTop'];
  static requiredClasses = [];

  static values = {
    debounceRate: {
      type: Number,
      default: 250
    }
  };

  // TARGETS
  declare siteHeaderTarget: HTMLDivElement;

  // CLASSES
  declare onTopClasses: string;
  declare overScrollTopClasses: string;

  // LOCAL STATE
  private debounceRateValue: number;
  private SCROLL_TOP_BREAKPOINT: number;

  initialize() {
    this.updateUi = debounce(this.updateUi, this.debounceRateValue).bind(this);
  }

  connect() {
    window.addEventListener('scroll', this.updateUi, { passive: true });
  }

  disconnect() {
    window.removeEventListener('scroll', this.updateUi);
  }

  updateUi(event) {
    const target = event.target.scrollingElement;

    if (target.scrollTop > SCROLL_TOP_BREAKPOINT) {
      this.siteHeaderTarget.classList.remove(...this.onTopClasses);
      this.siteHeaderTarget.classList.add(...this.overScrollTopClasses);
    } else {
      // is at the top of the page
      this.siteHeaderTarget.classList.remove(...this.overScrollTopClasses);
      this.siteHeaderTarget.classList.add(...this.onTopClasses);
    }
  }
}
